import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BillingAccountListRoutingModule } from './billing-account-list-routing.module';
import { BillingAccountListComponent } from './billing-account-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    BillingAccountListComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    InfiniteScrollModule,
    BillingAccountListRoutingModule
  ]
})
export class BillingAccountListModule { }
